// Personal / free email providers — not company domains, so skip them when
// deriving a brand/logo domain from an email host.
export const PERSONAL_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "ymail.com",
  "yahoo.co.uk",
  "yahoo.co.jp",
  "yahoo.de",
  "yahoo.fr",
  "outlook.com",
  "hotmail.com",
  "hotmail.co.uk",
  "live.com",
  "msn.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "protonmail.com",
  "proton.me",
  "pm.me",
  "tutanota.com",
  "tuta.io",
  "gmx.com",
  "gmx.de",
  "gmx.net",
  "fastmail.com",
  "fastmail.fm",
  "mail.com",
  "hey.com",
  "zoho.com",
  "qq.com",
  "163.com",
  "126.com",
  "yandex.com",
  "yandex.ru",
  "mail.ru",
]);
